// extracted by mini-css-extract-plugin
export default {"iconButton":"Settings_iconButton__Uisma","twitter":"Settings_twitter__i3aRI","GroupButton":"Settings_GroupButton__Uu9o+","LowerLinks":"Settings_LowerLinks__UtGuN"};